import { GetDelegateUserResponse } from '@eigtech/delegate-types'
import { isPortalUserActive } from '@eigtech/portals-types'
import { queryOptions, useQuery, useQueryClient } from '@eigtech/ui-shared-api'
import { useCheckIfAccessTokenSet } from '@eigtech/ui-shared-auth'
import { delegateBasePath } from '../constants'
import { get } from '../instance'
import { userQueryKeys } from './constants'

const getDelegateUser = async ({ auth0Id, email }: { auth0Id: string; email: string }) => {
  const delegateUsers = await get<GetDelegateUserResponse>(
    `${delegateBasePath}/user/${encodeURIComponent(auth0Id)}/${encodeURIComponent(email)}`
  )

  return delegateUsers.filter(isPortalUserActive)
}

export const getDelegateUserQueryOptions = ({
  accessTokenSet,
  ...request
}: {
  auth0Id: string
  email: string
  accessTokenSet: boolean
}) =>
  queryOptions({
    queryKey: userQueryKeys.status(),
    queryFn: () => getDelegateUser(request),
    enabled: accessTokenSet,
    retry: false, // retry manually based on returned status/error
  })

export function useGetDelegateUser(request: { auth0Id: string; email: string }) {
  const accessTokenSet = useCheckIfAccessTokenSet()
  return useQuery(getDelegateUserQueryOptions({ ...request, accessTokenSet }))
}

export function useInvalidateUserStatus() {
  const queryClient = useQueryClient()

  return function invalidateUserGroups() {
    queryClient.invalidateQueries({ queryKey: userQueryKeys.status() })
  }
}
